import { render, staticRenderFns } from "./PrevAIImage.vue?vue&type=template&id=70b7e5e0&scoped=true"
import script from "./PrevAIImage.vue?vue&type=script&lang=js"
export * from "./PrevAIImage.vue?vue&type=script&lang=js"
import style0 from "./PrevAIImage.vue?vue&type=style&index=0&id=70b7e5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b7e5e0",
  null
  
)

export default component.exports